import type { ApiRaceTips, RaceTips } from '@api/types/raceTips';

const adaptRaceTips = (data: ApiRaceTips): RaceTips => {
  return {
    id: data.id,
    raceAnalysis: data.raceAnalysis,
    runnersTips: data.runnersTips.map((tip) => ({
      runnerNumber: tip.runnerNumber,
      rank: tip.rank,
      category: tip.category,
      hearts: tip.hearts,
      journalistOdds: tip.journalistOdds,
      analysis: tip.analysis,
      interview: tip.interview,
    })),
  };
};

export { adaptRaceTips };
